import toast, { Toaster as HotToaster } from "react-hot-toast";

export const notify = {
  success: (title, description) =>
    toast.success(
      description ? `${title}\n${description}` : title,
      { duration: 4000 },
    ),
  error: (title, description) =>
    toast.error(
      description ? `${title}\n${description}` : title,
      { duration: 5000 },
    ),
};

export default function Toaster() {
  return (
    <HotToaster
      position="top-right"
      toastOptions={{
        className:
          "!rounded-lg !bg-slate-900 !text-white !text-sm !whitespace-pre-line",
        success: { iconTheme: { primary: "#14b8a6", secondary: "#0f172a" } },
        error: { iconTheme: { primary: "#f43f5e", secondary: "#0f172a" } },
      }}
    />
  );
}